const config = {
    backendIp: process.env.REACT_APP_BACKEND_IP || 'https://chatbot.internal-psel.com',
  };
  
  export default config;